var _mask, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBracket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_14942_6295",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.65723 0.842773L11.3141 6.49963L5.65723 12.1565L0.000371933 6.49963L5.65723 0.842773Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3141 6.49963L13.328 8.51359L15.342 6.49963L13.328 4.48567L11.3141 6.49963ZM3.64327 2.85673L9.30012 8.51359L13.328 4.48567L7.67118 -1.17118L3.64327 2.85673ZM9.30012 4.48567L3.64327 10.1425L7.67118 14.1704L13.328 8.51359L9.30012 4.48567Z",
    fill: "white",
    mask: "url(#path-1-inside-1_14942_6295)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBracket);
export default __webpack_public_path__ + "static/media/bracket.bbb7f84f1b5b0c8c15f2775dad417456.svg";
export { ForwardRef as ReactComponent };